import api from './api';
import { compressImageFile } from '@/utils/imageCompression';

export const getProfile = () => api.get('/api/player/profile');
export const updateProfile = (data) => api.put('/api/player/profile', data);

export const uploadAvatar = async (file) => {
  const imageFile = await compressImageFile(file, {
    maxWidth: 1024,
    maxHeight: 1024,
    maxSizeBytes: 2 * 1024 * 1024,
    outputType: 'image/jpeg',
  });
  const form = new FormData();
  form.append('avatar', imageFile);
  return api.post('/api/player/avatar', form);
};

export const generateAiAvatar = async (file, onUploadProgress) => {
  const imageFile = await compressImageFile(file, {
    maxWidth: 1024,
    maxHeight: 1024,
    maxSizeBytes: 2 * 1024 * 1024,
    outputType: 'image/jpeg',
  });
  const form = new FormData();
  form.append('photo', imageFile);
  return api.post('/api/player/avatar/ai', form, {
    timeout: 120000,
    onUploadProgress,
  });
};
export const getProgress = () => api.get('/api/player/progress');
export const getBadges = () => api.get('/api/player/badges');
export const getMissions = () => api.get('/api/player/missions');
export const getVisitHistory = (limit = 20) => api.get('/api/player/visits', { params: { limit } });
export const getNotifications = (page = 1) => api.get('/api/player/notifications', { params: { page } });
export const markNotificationsRead = (ids) => api.put('/api/player/notifications/read', { ids });
export const deleteAccount = () => api.delete('/api/player/account');
